<div>{{ formatDate(counter$ | async, { format: 'm:ss', timeZone: null, ignoreTimezone: true }) }}</div>
